module.exports = __webpack_public_path__ + "img/icon_calendar.8f9fb38c.svg";